import * as React from 'react';
import { DataGrid } from '@mui/x-data-grid';
import Paper from '@mui/material/Paper';
import { useState } from 'react';
import { Button } from '@mui/material';
import StatementViewModal from './StatementViewModal';


function formatDate(dateString) {
    const date = new Date(dateString);
  
    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const year = date.getFullYear();
    const formattedDate = `${day}-${month}-${year}`;
  
  
    return `${formattedDate}`;
  }
  
  function formatTime(dateString) {
    const date = new Date(dateString);
    let hours = date.getHours();
    const minutes = date.getMinutes().toString().padStart(2, '0');
    const seconds = date.getSeconds().toString().padStart(2, '0');
    const ampm = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12 || 12;
    const formattedHours = hours.toString().padStart(2, '0');
    const formattedTime = `${formattedHours}:${minutes}:${seconds} ${ampm}`;
    return `${formattedTime}`;
  }



const columnGroupingModel = 
    {
      groupId: 'transactional_details',
      headerName: 'Transactional details',
      children: [
        {field: 'reference_no',headerName: 'Reference no',width: 200,hide:true},
        {field: 'branch_code',headerName: 'Branch code',width: 200,hide:true},
        {field: 'credit',headerName: 'Credit',width: 200,hide:true},
        {field: 'closing_balance',headerName: 'Closing balance',width: 200,hide:true},
      ],
    }
  




export default function UpdateStatementTable(props) {
    const [ paginationModel ,setPaginationModal] = useState({page:0,pageSize:10});
    const[ModalOpen,setModalOpen]=useState(false)
    const[ModalData,setModalData]=useState(null)


    const handleModalOpen=(params)=>{
        setModalData(params.row.last_desc)
        setModalOpen(true)
    }

    const handleModalClose=()=>{
        setModalOpen(false)
    }


    const handlePageChange=(newPaginationModal)=>{
      console.log("page",newPaginationModal);
      
        setPaginationModal(newPaginationModal)
      
        props.setFilterData({...props.FilterData,page:newPaginationModal.page+1})
    }






    const columns = [
        { field: 'id', headerName: 'Batch Id', width: 100 },
        { field: 'bank_name', headerName: 'Bank name', width: 130 },
        { field: 'no_of_records', headerName: 'No of records', width: 200 },
        { field: 'account_no', headerName: 'Account Number', width: 200 },
        { field: 'uploaded_on', headerName: 'Upload & Time'
          , width: 250 ,
          renderCell: (params) => (
            <>
              {formatDate(params.row.uploaded_on)}
              /
              {formatTime(params.row.uploaded_on)}
          </>
          )
      },
        // {field: 'error_desc',headerName: 'Description',width: 200,
        //   renderCell: (params) => (
        //     <>
        //       {params.row.last_desc&&params.row.last_desc.Description?params.row.last_desc.Description:"-"}
        //     </>
        //   )
        // },
      
        {field: 'transactional_details',
          headerName: 'Last transactional Details',
          width: 250,
          renderCell:(params)=>(
              <>
                {<Button disabled={params.row.last_desc&&Object.keys(params.row.last_desc).length>0?false:true} onClick={()=>handleModalOpen(params)}>view</Button>}
              </>
        
          )
      },
      //   {
      //     field: 'transactional_details',
      //     headerName: 'Transactional details',
      //     width: 600,
          
      //   },
      //   {field: 'reference_no',headerName: 'Reference no',width: 200,hide:true},
      //   {field: 'branch_code',headerName: 'Branch code',width: 200,hide:true},
      //   {field: 'credit',headerName: 'Credit',width: 200,hide:true},
      //   {field: 'closing_balance',headerName: 'Closing balance',width: 200,hide:true},
      //   {field: 'status',headerName: 'Status',width: 200},
      
        
      ];
      
      console.log("Data",props.data);
      

  return (
    <Paper sx={{ height: 400, width: '100%' }}>
        <StatementViewModal open={ModalOpen} data={ModalData} handleClose={handleModalClose}/>
      <DataGrid
        rows={props.data&&props.data.data&&Array.isArray(props.data.data)?props.data.data:[]}
        columns={columns}
        columnGroupingModel={columnGroupingModel}
        initialState={{ pagination: { paginationModel } }}
        loading={props.IsLoading}
        pageSizeOptions={[10]}
        onPaginationModelChange={handlePageChange}
        rowCount={Math.ceil(props.data?props.data.total/10:0)}
        sx={{ border: 0 }}
      />
    </Paper>
  );
}
